<template>
  <div class="w-full font-proxima">
    <div class="overflow-x-auto shadow-sm ring-1 ring-black ring-opacity-5 rounded-sm bg-white">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-red-50">
          <tr>
            <th v-for="header in HEADERS" :key="header" class="p-2 text-left align-middle text-sm font-bold border border-white text-blue-500 whitespace-nowrap">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="(row, index) in rows" :key="row.id ?? index" :class="index % 2 === 0 ? undefined : 'bg-gray-100'">
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ dateTime(row.createdAt) }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.transactionType }}</td>
            <td class="px-3 py-2 text-sm text-black text-right whitespace-nowrap">{{ money(row.amountUsd) }}</td>
            <td class="px-3 py-2 text-sm text-black text-right whitespace-nowrap">{{ money(row.balanceAvailableUsd) }}</td>
            <td class="px-3 py-2 text-sm text-black">{{ row.comment || row.description }}</td>
            <td v-if="showBy" class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.by }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="mt-1 text-xs text-gray-500">
      Showing {{ rows.length.toLocaleString() }} of {{ (output?.count ?? rows.length).toLocaleString() }} transactions
    </p>
  </div>
</template>
<script setup lang="ts">
interface LedgerRow {
  id?: string;
  transactionType?: string;
  amountUsd?: number;
  balanceAvailableUsd?: number;
  comment?: string;
  description?: string;
  createdAt?: string;
  by?: string;
}

const props = defineProps<{ part: { output?: { count?: number; transactions?: LedgerRow[] } } }>();

const output = computed(() => props.part.output);
const rows = computed<LedgerRow[]>(() => output.value?.transactions ?? []);
// The funding-source ledger includes who made the change; the fund ledger doesn't
const showBy = computed(() => rows.value.some((r) => r.by));
const HEADERS = computed(() => ['Date', 'Type', 'Amount', 'Available', 'Note', ...(showBy.value ? ['By'] : [])]);

const money = (usd?: number) => (usd == null ? '' : formatNumberToMoney(usd));
const dateTime = (value?: string) =>
  value ? new Date(value).toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';
</script>
